import { DEFAULT_FILTERS } from '../constants';
import { toPairs, differenceWith, isEqual} from 'lodash';

const SEO_MODE_FILTERS_ALLOWED = ['area', 'seoMode', 'type[]', 'topology[]'];

export const SEO_MODE_KEYS_TO_IGNORE = ['area', 'seoMode', 'areaId'];

// If there are filters different to the default ones,
// and those are not in SEO_MODE_FILTERS_ALLOWED, then isSeoMode = false.
export const isSeoMode = filters => {
  const notDefaultFilters = differenceWith(toPairs(filters), toPairs(DEFAULT_FILTERS), isEqual);

  return notDefaultFilters.filter(
    // If 'area' is present, so it will be 'areaId[]', which needs to be removed in that case
    ([key, value]) => key !== 'areaId[]' || (key === 'areaId[]' && !filters.area)
  ).filter(
    // Remove filters that are SEO allowed
    ([key, value]) => !SEO_MODE_FILTERS_ALLOWED.includes(key)
  ).length === 0;
};

export const removeSeoFilters = filters => {
  return Object.keys(filters).reduce((newFilters, key) => {
    if (!['area', 'seoMode'].includes(key)) {
      newFilters[key] = filters[key];
    }
    return newFilters;
  }, {});
};

export default {
  SEO_MODE_KEYS_TO_IGNORE,
  isSeoMode,
  removeSeoFilters
};
